import { useLeaderboardStore } from '#leaderboards/store/useLeaderboardStore'
import { useQuery } from '@pinia/colada'

export function useLeaderboardPodiumData() {
  const store = useLeaderboardStore()

  const { data: aggregated, isLoading: isAggregatedLoading } = useQuery({
    ...buildApiQuerySSRSafe('/market-makers-leaderboard/aggregated', {
      method: 'get',
      params: () => ({
        query: {
          startDate: store.dateRange.startDate,
          endDate: store.dateRange.endDate,
        },
      }),
    }),
    refetchOnWindowFocus: false,
  })

  const { data: performance, isLoading: isPerformanceLoading } = useQuery({
    ...buildApiQuerySSRSafe('/market-makers-leaderboard/performance', {
      method: 'get',
      params: () => ({
        query: {
          startDate: store.dateRange.startDate,
          endDate: store.dateRange.endDate,
        },
      }),
    }),
    refetchOnWindowFocus: false,
  })

  const aggregatedById = computed(() =>
    new Map((aggregated.value ?? []).map(item => [item.marketMakerId, item] as const)),
  )

  const performanceById = computed(() =>
    new Map((performance.value ?? []).map(item => [item.marketMakerId, item] as const)),
  )

  return {
    performance,
    aggregatedById,
    performanceById,
    isLoading: computed(() => isAggregatedLoading.value || isPerformanceLoading.value),
  }
}
